module.exports = __webpack_public_path__ + "img/AT0000001642832.4c3a470e.png";